// Site content for OutreachByUsama — stats sourced from freelancer.com/u/usamatausif

export const siteConfig = {
  name: "OutreachByUsama",
  personName: "Usama Touseef",
  title: "Cold Email Specialist & Email Deliverability Architect",
  email: "hello@outreachbyusama.com",
  phone: "+92 300 0785892",
  whatsapp: "923000785892",
  telegram: "usamatausif",
  calendly: "https://calendly.com/usamatausif/30min",
  freelancerProfile: "https://www.freelancer.com/u/usamatausif?sb=t",
  location: "Pakistan · Clients worldwide",
  timezone: "GMT+5"
};

export const freelancerStats = {
  rank: "Top 3%",
  rankOf: "of 89M freelancers",
  status: "Preferred Freelancer",
  rating: "5.0",
  reviews: 33,
  onTime: "100%",
  onBudget: "100%",
  years: "8+",
  preferredBadge: "https://www.f-cdn.com/assets/main/en/assets/badges/preferred-freelancer/preferred-freelancer-v3.svg",
  verifiedBadge: "https://www.f-cdn.com/assets/main/en/assets/badges/verified/verified-v3.svg"
};

export const dnsChecks = [
  { label: "SPF", value: "v=spf1 include:_spf … ~all" },
  { label: "DKIM", value: "2048-bit · selector active" },
  { label: "DMARC", value: "p=reject · rua set" },
  { label: "rDNS", value: "PTR matches HELO" }
];

export const composerEmail = {
  to: "sarah@northwind-saas.com",
  subject: "Quick question about Northwind's outbound",
  body: "Hi Sarah — noticed you're hiring 3 SDRs. Usually means outbound works but doesn't scale yet.\n\nI help B2B teams book meetings with cold email that lands in the primary inbox — infrastructure, verified leads and copy, all in-house.\n\nWorth a 15-minute chat this week?",
  reply: "Sure — Thursday 2pm works. Send the invite?"
};

export const services = [
  {
    id: "cold-email",
    folder: "Outreach",
    title: "Cold Email Outreach",
    preview: "Multi-step sequences to decision-makers that land in the primary inbox and start conversations.",
    summary:
      "Done-for-you cold email: I research your ICP, write copy that sounds like a human, build multi-step sequences and manage replies — so your calendar fills with qualified calls instead of bounces.",
    deliverables: [
      "ICP research & messaging angles",
      "3–5 step sequences with A/B variants",
      "Inbox rotation, warm-up & daily monitoring",
      "Reply, bounce & unsubscribe handling",
      "Weekly reporting on opens, replies, meetings"
    ],
    specs: [
      ["Best for", "B2B SaaS, agencies, services"],
      ["Volume", "1k – 50k emails / month"],
      ["Timeline", "Live in 7–10 days"]
    ],
    icon: "Send"
  },
  {
    id: "infrastructure",
    folder: "Deliverability",
    title: "Email Infrastructure & Deliverability",
    preview: "Private SMTP servers, sending domains and SPF · DKIM · DMARC configured so mail actually arrives.",
    summary:
      "I build and own the plumbing: self-hosted SMTP, dedicated IPs, secondary domains, full DNS authentication and warm-up schedules. You get control, lower cost and inbox placement you can measure.",
    deliverables: [
      "Self-hosted SMTP server setup & hardening",
      "SPF, DKIM, DMARC, rDNS & BIMI records",
      "Domain & IP warm-up schedule",
      "Blacklist monitoring & reputation checks",
      "Migration off expensive SaaS senders"
    ],
    specs: [
      ["Stack", "Linux · SMTP · DNS · Postfix-class MTAs"],
      ["Outcome", "Primary-inbox placement"],
      ["Timeline", "3–5 days"]
    ],
    icon: "Server"
  },
  {
    id: "b2b-leads",
    folder: "Leads",
    title: "B2B Lead Generation",
    preview: "Verified decision-maker lists scraped from LinkedIn, Apollo and niche directories — clean, deduped, ready to send.",
    summary:
      "Custom lead lists built around your exact ICP: title, industry, headcount, funding, tech stack. Every email is triple-verified so bounce rates stay low and your domains stay healthy.",
    deliverables: [
      "ICP-matched lists from LinkedIn, Apollo & directories",
      "Custom Python / Scrapy scrapers for niche sources",
      "Triple email verification & deduplication",
      "Enrichment: funding, tech stack, headcount",
      "Delivered as CSV / Sheets / CRM import"
    ],
    specs: [
      ["Tools", "Apollo · LinkedIn · Python · Scrapy"],
      ["Accuracy", "< 3% bounce target"],
      ["Timeline", "2–5 days per list"]
    ],
    icon: "Target"
  },
  {
    id: "automation",
    folder: "Marketing",
    title: "Email Marketing Automation",
    preview: "Nurture flows, newsletters and lifecycle emails that turn leads into customers on autopilot.",
    summary:
      "Beyond cold outreach: segmented newsletters, drip and nurture sequences, re-engagement flows and list hygiene — measured by revenue, not opens.",
    deliverables: [
      "Welcome, nurture & re-engagement sequences",
      "Segmentation & behavioural triggers",
      "Newsletter design & scheduling",
      "List cleaning & deliverability hygiene",
      "Revenue-focused reporting"
    ],
    specs: [
      ["Platforms", "Any ESP or self-hosted stack"],
      ["Compliance", "CAN-SPAM · GDPR"],
      ["Timeline", "1–2 weeks"]
    ],
    icon: "Workflow"
  }
];

export const sequence = [
  {
    day: "Day 0",
    title: "Discovery & ICP",
    description: "A 30-minute call to define who you sell to, why they buy and what a qualified reply looks like.",
    tag: "Kick-off call",
    icon: "Search"
  },
  {
    day: "Day 1–3",
    title: "Infrastructure & warm-up",
    description: "Domains, SMTP and DNS (SPF · DKIM · DMARC) set up and warming. Lead lists scraped and verified.",
    tag: "SPF · DKIM · DMARC",
    icon: "Server"
  },
  {
    day: "Day 7",
    title: "Sequence goes live",
    description: "Copy variants launch to the first segment. Deliverability, opens and replies watched daily.",
    tag: "First replies",
    icon: "Send"
  },
  {
    day: "Day 14+",
    title: "Optimise & scale",
    description: "Winning angles get more volume, weak ones get cut. You receive a weekly report with the numbers.",
    tag: "Weekly report",
    icon: "TrendingUp"
  }
];

export const experience = [
  { period: "2023 — Present", role: "Preferred Freelancer · Top 3%", org: "Freelancer.com", detail: "5.0 rating · 33 reviews · 100% on time and on budget." },
  { period: "2017 — 2024", role: "Top Rated Plus", org: "Upwork", detail: "135+ completed projects in cold email, B2B lead generation and email automation." },
  { period: "2017 — 2026", role: "Top Rated Seller", org: "Fiverr", detail: "Nearly a decade of email marketing and lead-gen deliveries." },
  { period: "2014 — 2018", role: "BS Information Technology", org: "COMSATS University", detail: "The technical foundation behind the servers I build today." }
];

export const tools = ["Apollo", "LinkedIn Sales Navigator", "Python", "Scrapy", "Self-hosted SMTP", "SPF · DKIM · DMARC", "Google Workspace", "Microsoft 365", "Google Sheets"];

export const reviews = [
  {
    id: "animation-builders",
    from: "Animation Builders",
    role: "Project Manager · Client reference",
    subject: "Re: Email server setup + cold email campaigns",
    body: "I really recommend Usama. He set up our email server and ran our cold email campaigns. We got great results and more leads. He was easy to work with and knew what he was doing.",
    meta: "Server setup · Cold email",
    flag: null,
    initials: "AB"
  },
  {
    id: "sander",
    from: "Sander",
    role: "Founder · Canada",
    subject: "Re: Recently funded AI USA startups leads",
    body: "Excellent work! Usama was professional, fast, and delivered exactly what I needed. Highly recommend. Will work with him again.",
    meta: "Lead generation · 14 days ago",
    flag: "https://www.f-cdn.com/assets/main/en/assets/flags/ca.png",
    initials: "S"
  },
  {
    id: "michael",
    from: "Michael",
    role: "Repeat client · United States",
    subject: "Re: Beverage Campaign (3rd project)",
    body: "This is the third project. I will keep using him.",
    earlier: [
      { quote: "He is a true professional.", project: "Packaging Automation Campaign" },
      { quote: "He is very knowledgeable. I highly recommend him.", project: "B2B Lead Generation & Email Campaign Management" }
    ],
    meta: "B2B leads & email campaigns · 3 projects",
    flag: "https://www.f-cdn.com/assets/main/en/assets/flags/us.png",
    initials: "M"
  }
];
